"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezonedDate = getTimezonedDate;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
function getTimezonedDate(date, timezone) {
    return moment_timezone_1.default.tz(date, timezone);
}
//# sourceMappingURL=getTimezonedDate.js.map